import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from '../store/configureStore';
import App from './APDemoApp';
import { ApplicationState } from 'store/definitions';
import { graphDataUpdater } from './store/updater';

const startApDemo = () => {
  const baseUrl = document
    .getElementsByTagName('base')[0]
    .getAttribute('href') as string;

  console.log(
    'windowHref/loc:',
    window.location.href,
    window.location,
    window.location.pathname,
    baseUrl
  );

  const history = createBrowserHistory({ window, basename: baseUrl } as any);

  const setup = (initialData?: ApplicationState) => {
    // Get the application-wide store instance, prepopulating with state from the server where available.
    const store = configureStore(history, [graphDataUpdater], initialData);

    ReactDOM.render(
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>,
      document.getElementById('root')
    );
  };

  fetch('/apdemo/scratchdata')
    .then((resp) => {
      if (!resp.ok && resp.status === 404) {
        return undefined;
      }
      console.log(resp);
      return resp.json();
    })
    .then((initialState) => {
      console.log('Initial state:', initialState);
      setup(initialState);
    })
    .catch((err) => {
      console.log(err);
      setup(undefined);
    });
};

export default startApDemo;
